<template>
  <div class="main_container">
    <div
      :class="{
        container_bg: true,
        container_green: curBGVal === 'typeGreen' ? true : false,
      }"
      v-if="customerId != 3"
    >
      <img v-if="backgroundMask && !isBaoSteel && curBGVal != 'typeBlue'" :src="getContainerBG" />
    </div>
    <div class="overal_bg" v-if="curBGVal == 'typeDark'"></div>
    <div class="overal_bg_strong" v-if="curBGVal == 'typeStrong'"></div>
    <left-part :modelType="modelType" v-if="!isSetting && refreshTag"></left-part>
    <right-part :modelType="modelType" v-if="!isSetting && refreshTag"></right-part>
    <setting style="z-index: 2" :modelType="modelType" v-if="isSetting"></setting>
    <!--button class="changeSet" @click="click"></button-->

    <!-- <centerMod v-if="bme3dManagerLoaded" /> -->
    <duty-science v-if="refreshTag"></duty-science>

    <!-- <pupButton></pupButton> -->
    <!-- <emissionSource /> -->
  </div>
</template>

<script>
//这里可以导入其他文件（比如：组件，工具js，第三方插件js，json文件，图片文件等等）
//例如：import 《组件名称》 from '《组件路径》';
import leftPart from '@/modules/DIYcomponents/leftPart.vue'
import rightPart from '@/modules/DIYcomponents/rightPart.vue'
import setting from '@/modules/DIYcomponents/setting.vue'
import dutyScience from '@/modules/dutyComponents/dutyScience/index.vue'
import iframePup from '@/modules/iframePup/iframePup.vue'
import { getEncryptWithPassword } from '@/utils/cryptoUtil.js';
// import emissionSource from "@/modules/DIYcomponents/components/3_3/emissionSource/emissionSource.vue";
// import centerMod from "@/modules/centerMod/titleMenu/index.vue";
// import CEMSwindow from "@/modules/bubblePop/CEMSwindow/CEMSwindow.vue";

import { mapState, mapGetters } from 'vuex'

import { unorganizedLightWallRender } from '@/assets/js/lightWall/unorganized_science.js'
import { dutyLightWallRender } from '@/assets/js/lightWall/duty_science.js'

import { ref, shallowRef, computed, provide } from 'vue'

import { CamLeapFunc } from '@/assets/js/unity3D/index.js'

export default {
  //import引入的组件需要注入到对象中才能使用
  components: {
    leftPart,
    rightPart,
    setting,
    dutyScience
  },
  props: {},
  inject: ['updateCountNum', 'updateComponentsClose'],
  data() {
    //这里存放数据
    return {
      backgroundMask: bmeConfig.backgroundMask,
      customerId: this.$store.state.customerId,
      bme3dManagerLoaded: false,
      isSetting: false,
      hash: false,
      modelType: 'MainMod',
      styleType: '',
      styleTypeMap: styleTypeMap,
      // curBG: "",
      refreshTag: bmeConfig.isMainMenuShow,
      eventData: {},
      countStart: 0,
      countTimer: 0,
      curMapType: '',
      isBaoSteel: false
    }
  },
  //计算属性 类似于data概念
  // computed: {
  //   ...mapState([''])
  //   },
  computed: {
    getContainerBG: function () {
      let imgSrc = ''
      if (this.curBGVal && this.styleTypeMap[this.curBGVal] && this.styleTypeMap[this.curBGVal].dutyBG) {
        imgSrc = require('@/views/MainMod/img/' + this.styleTypeMap[this.curBGVal].dutyBG)
      }
      if (!bmeConfig.backgroundMask) {
        imgSrc = ''
      }
      //this.imgSrc = imgSrc;
      return imgSrc
    },
    curBGVal: function () {
      return this.$store.state.curBG
    },
    mapTypeVal() {
      return this.$store.state.mapType
    },
    currentWSCMD: function () {
      return this.$store.state.currentWSCMD
    },
    ...mapGetters({
      dialogCompontent: 'getDialogCompontent'
    })
  },
  provide: function () {
    return {
      getEventData: computed(() => this.eventData),
      updateEventData: this.updateEventData
    }
  },
  //监控data中的数据变化
  watch: {
    hash: {
      handler(newVal, oldVal) {
        this.isSetting = newVal
      },
      deep: true
    },
    // curBGVal: {
    //   handler(newVal, oldVal) {
    //     this.curBG = newVal;
    //   },
    //   deep: true,
    // },
    mapTypeVal: {
      handler(newVal, oldVal) {
        this.curMapType = newVal
      },
      deep: true
    },
    currentWSCMD(newval) {
      console.log(newval)
      if (newval && newval.indexOf('startPeople') >= 0) {
        window.digitalPlay.cb()
      } else if (newval && newval.indexOf('startLowcode') >= 0) {
        window.digitalStop.cb()
        this.openPup('https://vis.bmetech.com/standard/vis/page/DiyReporter/index.html#/homePage?customAuto=true')
        setTimeout(() => {
          this.$popup.close(this, 'diyReporter')
          this.$router.push('/UnorganizedMod?customerId=42'+(window.bmeConfig.isEnkey ? `&enKey=${getEncryptWithPassword()}` : ''))
        }, 35000)
      } else {
        window.digitalStop.cb()
      }
    }
  },
  //方法集合
  methods: {
    flyTo() {
      if (window.g_bme3dManager && window.g_bme3dManager.earth) {
        const earth = window.g_bme3dManager.earth
        let view = mapViews[`mapViews_${this.customerId}`] && mapViews[`mapViews_${this.customerId}`].dutyMod
        if (view && view.length) {
          earth.camera.flyTo(view[0], view[1], view[2], view[3])
        } else {
          g_bme3dManager.flyAround()
        }
      }
    },
    isBme3dManagerLoaded() {
      if (bmeConfig.mapType !== '3D') return
      if (window.g_bme3dManager && window.g_bme3dManager.earth) {
        this.bme3dManagerLoaded = true
        this.flyTo()
      } else {
        let that = this
        if (that.loadedTimer) {
          clearTimeout(that.loadedTimer)
        }
        that.loadedTimer = setTimeout(function () {
          that.isBme3dManagerLoaded()
        }, 100)
      }
    },
    updateEventData(item) {
      this.eventData = item
    },
    reset() {
      this.modelType = 'MainMod'
      this.refreshTag = bmeConfig.isMainMenuShow
      this.eventData = {}
    },
    reload() {
      let that = this
      this.refreshTag = false
      this.$nextTick(() => {
        this.reset()
      })
    },
    stopEnough() {
      return
    },
    // 阻止同时控制组件和3D场景
    stopControl() {
      console.log(bmeConfig)
      // console.log(e,CamFixFunc)
      // if(e) {
      //   CamFixFunc()
      // }
    },
    openPup(url) {
      this.$store.commit('dialogStatus', true)
      this.$popup.open(
        iframePup,
        this.dialogCompontent,
        this,
        {
          dialog: url,
          special: true
        },
        null,
        'diyReporter'
      )
    }
  },
  //生命周期 - 创建完成（可以访问当前this实例）
  created() {
    let that = this
    this.styleType = bmeConfig.styleType
    if (this.$route.query && this.$route.query.setting == 'true') {
      this.hash = true
    } else {
      this.hash = false
    }
    this.curMapType = this.$store.state.mapType
  },
  //生命周期 - 挂载完成（可以访问DOM元素）
  mounted() {
    let that = this
    // this.curBG = this.$store.state.curBG;

    this.$countStart.timeStemp = new Date().getTime()
    this.stopEnough()

    this.isBaoSteel = bmeConfig.isBaoSteel
    //alert(222222222);
  },
  activated() {
    let that = this

    //this.countStart = new Date().getTime();
    this.$countStart.timeStemp = new Date().getTime()
    this.stopEnough()
  }, //如果页面有keep-alive缓存功能，这个函数会触发
  deactivated() {
    /*if (this.countTimer) {
      clearTimeout(this.countTimer);
      this.countStart = new Date().getTime();
    }*/
  },
  beforeRouteUpdate(to, from) {
    if (to.query && to.query.setting == 'true') {
      this.hash = true
    } else {
      this.hash = false
    }
    //console.log(2222);
    this.reload()
  },
  beforeUnmount() {},
  beforeRouteLeave(to, from) {
    // ...
    /*this.updateCountNum(0);
    if (this.countTimer) {
      clearTimeout(this.countTimer);
    }
    next();*/
  },
  beforeRouteEnter(to, from) {
    //dutyLightWallRender(true, "update");
    //unorganizedLightWallRender(false);
    //CamLeapFunc();
  }
}
</script>
<style scoped>
.main_container {
  position: absolute;
  left: 0px;
  top: 0px;
  bottom: 0px;
  right: 0px;
}

.container_bg {
  position: absolute;
  left: 0px;
  top: 0px;
  bottom: 0px;
  right: 0px;
  z-index: -1;
}

.container_bg > img {
  filter: opacity(100%) grayscale(15%) blur(1px) contrast(95%) saturate(95%);
  width: 102%;
  height: 100%;
}

.container_green {
  filter: opacity(70%) grayscale(15%) blur(1px) contrast(95%) saturate(95%) !important;
}

.overal_bg {
  position: absolute;
  left: 15px;
  top: 120px;
  bottom: 15px;
  right: 15px;
  background-image: url('/static/images/common/overal.png');
  background-size: 100% 100%;
  background-repeat: 'no-repeat';
  z-index: -1;
}
.overal_bg_strong {
  position: absolute;
  left: 15px;
  top: 120px;
  bottom: 15px;
  right: 15px;
  background-image: url('/static/images/common/overal.png');
  background-size: 100% 100%;
  background-repeat: 'no-repeat';
  z-index: -1;
}

.changeSet {
  display: block;
  height: 100px;
  width: 100px;
  background: black;
  position: absolute;
  top: 0px;
  left: 0px;
  pointer-events: all;
}
</style>
